import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';
import { RctCard, RctCardContent } from 'Components/RctCard';

import { 
    fetchOCTApproachChart,
    fetchOnDrivingChart,
    fetchShortGameShotChart,
    fetchOnWedgeChart,
    fetchOnBunkerChart,
    studentOCScoring,
    fetchPlayerIntervention
 } from 'Actions';

 import LongGame from './courselonggame';
 import ShortGame from './courseshortgame';
 import CourseScore from './coursescore';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class GolfCourseTest extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        
	}
    constructor(props) {
      
        super(props);
        let startDate = new Date();
        let befrstart=new Date(startDate.setMonth(startDate.getMonth() - 2));
        this.state = {  
            student:this.props.data.student, 
            startdate:'',
            enddate:'',
            loader:false,
            maindiv:true,
            longgame:false,
            shortgame:false,
            puttgame:false,
        };

        this.onBackSection = this.onBackSection.bind(this);
    }

    rangeSelection(id){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        var contact='';
        var area='';
        var shot='';
        var club='';
        var distance='';
       if(id==1){
        this.props.fetchOCTApproachChart(student, stdate, eddate, distance, area, contact);
        this.props.fetchOnDrivingChart(student, stdate, eddate, contact, club, area);
                this.setState({ 
                    maindiv:false,
                    shortgame:false,
                    puttgame:false,
                    longgame:true,
                });
        }else if(id==2){
            this.props.fetchShortGameShotChart(student, stdate, eddate, distance, area, contact);
            this.props.fetchOnWedgeChart(student, stdate, eddate, distance, area, contact);
            this.props.fetchOnBunkerChart(student, stdate, eddate, contact);
                this.setState({ 
                    maindiv:false,
                    longgame:false,
                    puttgame:false,
                    shortgame:true,
                });
        }else if(id==3){
            this.props.studentOCScoring(student, stdate, eddate);
                this.setState({ 
                    maindiv:false,
                    longgame:false,
                    shortgame:false,
                    puttgame:true,
                });
        }
    }

    onBackSection() {
        var student=this.state.student;
        var stdate='';
        var eddate='';
        this.props.fetchPlayerIntervention(student, stdate, eddate).then((data) => {
            this.setState({ 
                maindiv:true,
                longgame:false,
                shortgame:false,
                puttgame:false,
            });

        });    
	}


render() {

    const { playerinterventionlist, loading} = this.props;   
    

      return(
        <div>   
                {this.state.maindiv && 
                <>
                <div className="row" style={{marginBottom:"20px"}}>
                    <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                    <div className="col-lg-8"><h2 className="text-center">ON COURSE TESTS</h2></div>
                    <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.props.onClick1(1)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                </div>
                <div className="row" style={{display:"flex",justifyContent: "center"}}>
                    
                     <div className="col-sm-12 col-lg-3 custom-class">
                        <RctCard>
                            <a onClick={() =>this.rangeSelection(1)}>
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/curs_longgame.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">ON COURSE LONG GAME</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.oncoursetest.longgametot}</strong></div>
                              </RctCardContent>
                            </a>  
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3 custom-class">
                        <RctCard>
                            <a onClick={() =>this.rangeSelection(2)}>
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/curs_shortgame.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">ON COURSE SHORT GAME</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.oncoursetest.shortgametot}</strong></div>
                              </RctCardContent>
                            </a>  
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3 custom-class">
                        <RctCard>
                            <a onClick={() =>this.rangeSelection(3)}>
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/curs_scoring.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">ON COURSE SCORING</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.oncoursetest.scoretotal}</strong></div>
                              </RctCardContent>
                            </a>  
                        </RctCard>      
                     </div>     
                    
                </div>  
            </>        
            } 
            
            {this.state.longgame &&
               <LongGame onClick={() => this.props.onClick()} onClick1={this.onBackSection} data={this.state}/>
            }

            {this.state.shortgame &&
               <ShortGame onClick={() => this.props.onClick()} onClick1={this.onBackSection} data={this.state}/>
            }

            {this.state.puttgame&&
               <CourseScore onClick={() => this.props.onClick()} onClick1={this.onBackSection} data={this.state}/>
            }

        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention }) => {
    const { playerinterventionlist, loading } = playerintervention;
    return { playerinterventionlist, loading };
   
}


export default connect(mapStateToProps, {
    fetchOCTApproachChart,
    fetchOnDrivingChart,
    fetchShortGameShotChart,
    fetchOnWedgeChart,
    fetchOnBunkerChart,
    studentOCScoring,
    fetchPlayerIntervention
})(GolfCourseTest);
